import { render, staticRenderFns } from "./PaySuccessShorex.vue?vue&type=template&id=28d40a38&scoped=true"
import script from "./PaySuccessShorex.vue?vue&type=script&lang=js"
export * from "./PaySuccessShorex.vue?vue&type=script&lang=js"
import style0 from "./PaySuccessShorex.vue?vue&type=style&index=0&id=28d40a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d40a38",
  null
  
)

export default component.exports